export default __webpack_public_path__ + "static/media/welcome-bg10.4f380c47.png";